import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Content from '../../configurations/content';
import Map from '../../configurations/map';
import { selectMapHolderOffset } from '../../services/store/modules/app-controls';
import { selectCurrentMemberId } from '../../services/store/modules/backend-service';
import { fetchMarketplaceCategories } from '../../services/store/modules/marketplace';
import {
  getIsShowingSubscriptionSuccess,
  showSubscriptionSuccess,
} from '../../services/store/modules/subscriptions';
import theme from '../../theme';
import AppControls from '../containers/AppControls/AppControls';
import DesktopNavLayout from '../features/AppNavigation/DesktopNavLayout';
import SubscriberWelcome from '../features/Subscriber/components/SubscriberWelcome/SubscriberWelcome';
import OneSignalComp from '../null-components/OneSignal/OneSignal';
import AppOffline from '../pages/AppOffline/AppOffline';
import SheetModal from '../shared/SheetModal/SheetModal';

import './raw.scss';
import classes from './view.scss';

const cx = classNames.bind(classes);

const Root = (props) => {
  const { history } = props;
  const dispatch = useDispatch();
  const mapHolderOffset = useSelector(selectMapHolderOffset);
  const memberId = useSelector(selectCurrentMemberId);

  const isShowingSubscriptionSuccess = useSelector(
    getIsShowingSubscriptionSuccess,
  );

  useEffect(() => {
    // Fetching categories is an euthenticated call. Having this here prevents a redirect loop of trying to get
    // categories, which will return a 401, which reloads the page, which attempts to fetch categories!
    if (memberId) {
      dispatch(fetchMarketplaceCategories());
    }
  }, [dispatch, memberId]);

  const isTesting = window.location.href.indexOf('//deckee.com') === -1;
  const testingDomain = window.location.hostname;
  const appOffline = window?.DECKEE_CONFIG?.appOffline;

  return (
    <ThemeProvider theme={theme}>
      <OneSignalComp />
      {isTesting && (
        <div
          style={{ zIndex: 99999999999999 }}
          className={cx('domainNotifier')}
        >
          {testingDomain}
        </div>
      )}

      <SheetModal isOpen={isShowingSubscriptionSuccess}>
        <SubscriberWelcome
          onContinue={() => {
            dispatch(showSubscriptionSuccess(false));
          }}
        />
      </SheetModal>

      <Router basename="/" history={history}>
        {appOffline ? (
          <AppOffline />
        ) : (
          <>
            <div id="rootContainer" className={cx('root')}>
              <DesktopNavLayout>
                <AppControls />
                <Content />
                <Map mapHolderOffset={mapHolderOffset} />
              </DesktopNavLayout>
            </div>
          </>
        )}
      </Router>
    </ThemeProvider>
  );
};

Root.propTypes = {
  history: PropTypes.shape({}).isRequired, // Input
};

export default Root;
